import {Component, OnDestroy, OnInit} from '@angular/core';
import {SurveyModule} from "survey-angular-ui";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {ServerValidateQuestionsEvent, SurveyModel} from 'survey-core';
import {LoginRequest, SurveyErrors} from "dci-service-shared";
import {firstValueFrom, Unsubscribable} from "rxjs";
import {environment} from "../../../environments/environment";
import {SessionService} from "../../services/session.service";
import {ActivatedRoute, Router} from "@angular/router";
import {SurveyService} from "../../services/survey.service";
import {DobAnswer} from "@allaihealth/angular-survey";
import {SubscriptionHandler} from "../../util/subscription-handler";

@Component({
	selector: 'app-auth',
	imports: [SurveyModule],
	templateUrl: './auth.component.html',
	styleUrl: './auth.component.scss'
})
export class AuthComponent implements OnInit, OnDestroy {
	/** Notification from the survey to authenticate the user */
	private serverValidationSubscription:Unsubscribable;

	/** The currently displayed SurveyJS survey */
	model:SurveyModel;

	constructor(private http:HttpClient,
	            private activatedRoute:ActivatedRoute,
	            private sessionService:SessionService,
	            private router:Router,
	            private surveyService:SurveyService) {
	}

	async ngOnInit() {
		this.model = this.surveyService.newSurvey();

		this.model.fromJSON(this.surveyService.commonModules.authForm);

		this.serverValidationSubscription = SubscriptionHandler.getEventSubscription(this.model.onServerValidateQuestions,
			(_sender, options) => this.authenticate(options));
	}

	ngOnDestroy() {
		this.serverValidationSubscription?.unsubscribe();
		this.model.dispose();
	}

	/** Authenticate the user with the backend */
	private async authenticate(options:ServerValidateQuestionsEvent) {
		this.model.beginLoading();

		try {
			const surveyId = this.activatedRoute.snapshot.paramMap.get("surveyId");

			const dob = <DobAnswer>this.model.data['dob-auth'];

			const request:LoginRequest = {
				surveyLink: surveyId,
				dob
			};

			const response = await firstValueFrom(this.http.post(`${environment.apiUrl}/dci/login`,
				request, {observe: 'response'}));

			this.sessionService.setSession(response.headers.get("session"));

			await this.router.navigate(["/", surveyId, 0]);
		} catch(e) {
			console.error("Login error", e);

			if(e instanceof HttpErrorResponse && e.error != SurveyErrors.SurveyLoginFailed) {
				await this.router.navigate(['/error', e.error]);
			} else {
				options.errors["dob-auth"] = "This birthdate doesn't match the date on record. Please try again or contact the doctor's office.";
			}
		}

		options.complete();
		this.model.endLoading();
	}
}
